export default {
  hpTopImg: require("./logo.svg"),
  // hpMiddleImg: require("./home-visuel.jpg"),
  hpMiddleImg: require("./montage-home.png"),
  ouestFranceImg: require("./ouest-france.png"),
  ouestFranceImgBlanc: require("./logo-OF-blanc.png"),
  logoBotImg: require("./logo-bot.png"),
};
